angular.module('rentalListingModule').component('rentalListingUserInfo', {
	templateUrl: 'rentalListingUserInfo/rentalListingUserInfo.html',
	bindings: {
		form: '<',
		user: '<',
		listing: '<',
		isMobile: '<',
		userName: '<',
		errorMessages: '<',
		onFieldChange: '&'
	},
	controller: ['$http', function($http) {
		if (this.form) {
			this.form.$setPristine();
		}

		this.fieldChange = function(key) {
			this.onFieldChange({key: key});
		};
	}]
});
